<template>
  <div class="form-container">
    <CreateCampaignForm
      :show-loader="isCreationPending"
      @save="onSave($event)"
      @dismiss="dismissForm()"
    />
  </div>
</template>

<script>
import CreateCampaignForm from './CreateCampaignForm.vue';
import {CREATE_CAMPAIGN} from '../store/actionTypes';
import { mapActions, mapGetters, mapState } from 'vuex';
import { STATUS_ERROR, STATUS_PENDING, STATUS_SUCCESS } from '@/store/helpers';
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import { utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';

import messages from '../locales';
import sharedMessages from '@/core/locales';

export default {
  components: {CreateCampaignForm},
  computed: {
    ...mapGetters('campaigns', ['createCampaignStatus']),
    isCreationPending() {
      return this.createCampaignStatus.status == STATUS_PENDING;
    }
  },
  methods: {
    ...mapActions('campaigns', {'createCampaign': CREATE_CAMPAIGN}),
    dismissForm() {
      this.$emit('onDismiss');
    },
    async onSave(campaign) {
      await this.createCampaign(campaign);
      if (this.createCampaignStatus.status == STATUS_SUCCESS) {
        $ngStateService.go('dashboard.campaign', {
          campaignId: this.createCampaignStatus.campaignId
        });
      } else {
        if (this.createCampaignStatus.status == STATUS_ERROR) {
          utilities.showToaster(STATUS_ERROR, this.createCampaignStatus.error);
        }
      }
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style>

</style>